/**
 * UI Compatibility Layer
 * Provides uni.showToast, uni.showLoading, etc. using Vant components
 */

import { showToast as vantShowToast, showLoadingToast, closeToast, showDialog } from 'vant'

/**
 * Show toast message
 */
export function showToast(options) {
  if (typeof options === 'string') {
    options = { title: options }
  }

  const { title, icon, duration = 2000, mask = false } = options

  vantShowToast({
    message: title,
    icon: icon || 'none',
    duration,
    overlay: mask,
  })
}

/**
 * Show loading
 */
export function showLoading(options = {}) {
  const { title = 'Loading...', mask = true } = options
  showLoadingToast({
    message: title,
    overlay: mask,
    forbidClick: true,
  })
}

/**
 * Hide loading
 */
export function hideLoading() {
  closeToast()
}

/**
 * Show modal dialog
 */
export function showModal(options) {
  const {
    title = '提示',
    content = '',
    showCancel = true,
    cancelText = '取消',
    confirmText = '确定',
    success,
    fail,
  } = options

  showDialog({
    title,
    message: content,
    showCancelButton: showCancel,
    cancelButtonText: cancelText,
    confirmButtonText: confirmText,
  })
    .then(() => {
      if (success) {
        success({ confirm: true, cancel: false })
      }
    })
    .catch(() => {
      if (success) {
        success({ confirm: false, cancel: true })
      }
    })
}

export default {
  showToast,
  showLoading,
  hideLoading,
  showModal,
}

